import $ from "jquery";

(async () => {
    const els = $(".dpl-klaviyo, .block-editor");
    if (els.length > 0) {
        await import('./scripts/Client.js');
    }
})();
